// Acilista backend ile surum uyumunu kontrol eder:
//  - kendi surumunu backend'e bildirir (deploy gecmisi icin)
//  - backend'in bildirdigi uyumlu frontend araligiyla karsilastirir
//  - uyumsuzsa sayfanin ustune uyari bandi ekler
import { APP_VERSION, APP_COMMIT, APP_ENV } from "../version";
import { checkFrontendCompatibility } from "./versionCompat";
import axiosInstance from "../store/actions/axiosConfig";
import { store } from "../index";

const API_URL =
  process.env.NODE_ENV === "production"
    ? "https://api.test.raborisk.ai"
    : "http://localhost:3000";

const BANNER_ID = "rabo-version-mismatch-banner";

function showBanner(message) {
  if (document.getElementById(BANNER_ID)) return;
  const bar = document.createElement("div");
  bar.id = BANNER_ID;
  bar.setAttribute("role", "alert");
  bar.style.cssText =
    "position:fixed;top:0;left:0;right:0;z-index:99999;background:#b91c1c;color:#fff;" +
    "font:500 13px/1.4 system-ui,sans-serif;padding:10px 16px;display:flex;" +
    "align-items:center;justify-content:center;gap:12px;box-shadow:0 1px 4px rgba(0,0,0,.2)";

  const text = document.createElement("span");
  text.textContent = message;

  const reload = document.createElement("button");
  reload.textContent = "Yenile";
  reload.style.cssText =
    "background:#fff;color:#b91c1c;border:0;border-radius:6px;padding:4px 12px;" +
    "font-weight:600;cursor:pointer";
  reload.onclick = () => window.location.reload(true);

  const close = document.createElement("button");
  close.textContent = "\u2715";
  close.style.cssText =
    "background:transparent;color:#fff;border:0;font-size:16px;cursor:pointer;line-height:1";
  close.onclick = () => bar.remove();

  bar.appendChild(text);
  bar.appendChild(reload);
  bar.appendChild(close);
  document.body.appendChild(bar);
}

function isPlatformSuperAdmin() {
  try {
    const profile = store.getState()?.profile?.profile;
    return Number(profile?.is_super_admin) === 1 && profile?.isMasterDb === true;
  } catch {
    return false;
  }
}

export function installVersionGuard() {
  // Surum kontrolu yalnizca super admin icin calisir; endpoint de super admin'e baglidir.
  if (!isPlatformSuperAdmin()) return;

  // Sayfa ilk yuku bloklamasin diye bilerek "fire-and-forget".
  // axiosInstance interceptor'u Authorization + tenant header'larini ekler.
  axiosInstance
    .get(`${API_URL}/api/version`)
    .then((res) => {
      const data = res?.data;
      if (!data) return;

      // Kendi surumunu bildir (hata onemsiz)
      axiosInstance
        .post(`${API_URL}/api/version/report`, {
          version: APP_VERSION,
          commit: APP_COMMIT,
          environment: APP_ENV,
        })
        .catch(() => {});

      const state = checkFrontendCompatibility(APP_VERSION, data.compatibleFrontend);
      if (state === "too_old") {
        showBanner(
          `Uygulama guncellendi. Acik olan surumunuz (v${APP_VERSION}) eski, ` +
            `lutfen sayfayi yenileyin.`
        );
      } else if (state === "too_new") {
        showBanner(
          `Frontend surumunuz (v${APP_VERSION}) backend'den ileride. ` +
            `Backend guncellemesi bekleniyor olabilir.`
        );
      }
    })
    .catch(() => {
      // yetki yoksa (403) veya backend'e ulasilamiyorsa sessiz gec
    });
}
